import apiHeader from '@/helpers/apiHeader';

const sapSyncParamsService = {
  list(params) {
    return apiHeader.get('sap/sap-configuration-params', { params });
  },
  get(id) {
    return apiHeader.get('sap/sap-configuration-params/' + id);
  },
  create(data) {
    return apiHeader.post(`sap/sap-configuration-params`, data);
  },    
  update(id, data) {
    return apiHeader.put(`sap/sap-configuration-params/${id}`, data);
  },
  delete(id) {
    return apiHeader.delete(`sap/sap-configuration-params/${id}`);
  },
  getSapSyncParamsMappingList(sapSyncParam, params) {
    return apiHeader.get(`sap/sap-configuration-param-mappings/${sapSyncParam}`, {params})
  },
  getSapSyncParamsMapping(id) {
    return apiHeader.get(`sap/sap-configuration-param-mappings/${id}`);
  },
  deleteMapping(id) {
    return apiHeader.delete(`sap/sap-configuration-param-mappings/${id}`);
  },
  updateMapping(id, data) {
    return apiHeader.put(`sap/sap-configuration-param-mappings/${id}`, data);
  },
  createMapping(newData) {
    return apiHeader.post(`sap/sap-configuration-param-mappings`, newData);
  },

};

export default sapSyncParamsService;
